/**
 * FilterDialogHeader Component
 * 
 * Header section for the filter dialog with title and close button.
 */

import { HOME_V2_COLORS } from '../colors';

interface FilterDialogHeaderProps {
  onClose: () => void;
}

/**
 * Close Icon (X) Component
 * Source: docs/references/mockups/home-v2/close.svg
 */
function CloseIcon({ size = 24, color = HOME_V2_COLORS.dialogCloseButton }: { size?: number; color?: string }) {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path 
        d="M13.4158 12.0041L17.7158 7.71409C17.9041 7.52579 18.0099 7.27039 18.0099 7.00409C18.0099 6.73779 17.9041 6.4824 17.7158 6.29409C17.5275 6.10579 17.2721 6 17.0058 6C16.7395 6 16.4841 6.10579 16.2958 6.29409L12.0058 10.5941L7.7158 6.29409C7.52749 6.10579 7.2721 6 7.0058 6C6.7395 6 6.4841 6.10579 6.2958 6.29409C6.10749 6.4824 6.00171 6.73779 6.00171 7.00409C6.00171 7.27039 6.10749 7.52579 6.2958 7.71409L10.5958 12.0041L6.2958 16.2941C6.20207 16.3871 6.12768 16.4977 6.07691 16.6195C6.02614 16.7414 6 16.8721 6 17.0041C6 17.1361 6.02614 17.2668 6.07691 17.3887C6.12768 17.5105 6.20207 17.6211 6.2958 17.7141C6.38876 17.8078 6.49936 17.8822 6.62122 17.933C6.74308 17.9838 6.87379 18.0099 7.0058 18.0099C7.13781 18.0099 7.26852 17.9838 7.39038 17.933C7.51223 17.8822 7.62284 17.8078 7.7158 17.7141L12.0058 13.4141L16.2958 17.7141C16.3888 17.8078 16.4994 17.8822 16.6212 17.933C16.7431 17.9838 16.8738 18.0099 17.0058 18.0099C17.1378 18.0099 17.2685 17.9838 17.3904 17.933C17.5122 17.8822 17.6228 17.8078 17.7158 17.7141C17.8095 17.6211 17.8839 17.5105 17.9347 17.3887C17.9855 17.2668 18.0116 17.1361 18.0116 17.0041C18.0116 16.8721 17.9855 16.7414 17.9347 16.6195C17.8839 16.4977 17.8095 16.3871 17.7158 16.2941L13.4158 12.0041Z" 
        fill={color}
      />
    </svg>
  );
}

export default function FilterDialogHeader({ onClose }: FilterDialogHeaderProps) {
  return (
    <div className="relative flex items-center justify-center px-6 pt-6 pb-4">
      {/* Title - centered */}
      <h2 
        className="text-2xl font-semibold text-center"
        style={{ 
          color: HOME_V2_COLORS.dialogTitle,
          letterSpacing: '-0.96px',
          lineHeight: 'normal',
        }}
      >
        Make it your own
      </h2>
      
      {/* Close Button - absolute positioned on the right */}
      <button
        type="button"
        onClick={onClose}
        className="absolute right-4 p-2 rounded-full hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2"
        style={{ 
          // Focus ring color
          '--tw-ring-color': HOME_V2_COLORS.dialogCloseButton,
        } as React.CSSProperties}
        aria-label="Close dialog"
      >
        <CloseIcon size={24} />
      </button>
    </div>
  );
}
